import { DIMMED_POINT_OPACITY } from 'enums/charts.enums';
import { IPlotHoverKeys } from 'interfaces/i-pitch-performance';
import { PitchType } from 'lib_ts/enums/pitches.enums';
import { IGroupedFires } from 'lib_ts/interfaces/data/i-pitch-performance';

export class PitchPerformanceHelper {
  static groupHoverKey(groupId: string): string {
    return `group:${groupId}`;
  }

  static refGroupHoverKey(groupId: string): string {
    return `ref-group:${groupId}`;
  }

  static typeHoverKey(pitchType: PitchType): string {
    return `type:${pitchType}`;
  }

  static hoverKeys(group: IGroupedFires): IPlotHoverKeys {
    return {
      itemKey: PitchPerformanceHelper.groupHoverKey(group._id),
      highlightKeys: [
        PitchPerformanceHelper.groupHoverKey(group._id),
        PitchPerformanceHelper.typeHoverKey(group.pitch.type),
      ],
    };
  }

  static refHoverKeys(group: IGroupedFires): IPlotHoverKeys {
    return {
      itemKey: PitchPerformanceHelper.refGroupHoverKey(group._id),
      highlightKeys: [PitchPerformanceHelper.refGroupHoverKey(group._id)],
    };
  }

  static hoverOpacity(
    hoveredItemKey: string | undefined,
    keys: IPlotHoverKeys | undefined,
    baseOpacity: number
  ): number {
    const highlightKeys =
      keys?.highlightKeys ?? (keys?.itemKey ? [keys.itemKey] : []);

    if (
      !hoveredItemKey ||
      highlightKeys.length === 0 ||
      highlightKeys.includes(hoveredItemKey)
    ) {
      return baseOpacity;
    }

    return DIMMED_POINT_OPACITY;
  }
}
